import { API_BASE_URL } from './api';

const SESSION_KEY = 'attribution_fingerprint_sent';

/**
 * Captures UTM params, click ids (gclid, fbclid, ttclid, rdt_cid), and prospect ``eclid``
 * from the URL, then POSTs a fingerprint to the backend for later matching
 * with mobile app signups. Fires once per session, fails silently.
 */
export function captureAttributionFingerprint(): void {
  if (sessionStorage.getItem(SESSION_KEY)) return;

  const params = new URLSearchParams(window.location.search);
  const utm_source = params.get('utm_source');
  const utm_medium = params.get('utm_medium');
  const utm_campaign = params.get('utm_campaign');
  const utm_content = params.get('utm_content');
  const utm_term = params.get('utm_term');
  const gclid = params.get('gclid');
  const fbclid = params.get('fbclid');
  const ttclid = params.get('ttclid');
  const rdt_cid = params.get('rdt_cid');
  const eclid = params.get('eclid');
  const landingPath = window.location.pathname;
  const referrer = document.referrer || undefined;

  const excludedPrefixes = ['/admin', '/app', '/auth', '/purchase', '/v1'];
  const isMarketingPath = !excludedPrefixes.some((prefix) => landingPath.startsWith(prefix));

  // Capture if there are attribution params OR a marketing landing path/referrer.
  if (
    !isMarketingPath &&
    !utm_source &&
    !utm_medium &&
    !utm_campaign &&
    !utm_content &&
    !utm_term &&
    !gclid &&
    !fbclid &&
    !ttclid &&
    !rdt_cid &&
    !eclid
  ) {
    return;
  }

  sessionStorage.setItem(SESSION_KEY, '1');

  const body: Record<string, string | number> = {
    screen_width: window.screen.width,
    screen_height: window.screen.height,
  };

  if (utm_source) body.utm_source = utm_source;
  if (utm_medium) body.utm_medium = utm_medium;
  if (utm_campaign) body.utm_campaign = utm_campaign;
  if (utm_content) body.utm_content = utm_content;
  if (utm_term) body.utm_term = utm_term;
  if (gclid) body.gclid = gclid;
  if (fbclid) body.fbclid = fbclid;
  if (ttclid) body.ttclid = ttclid;
  if (rdt_cid) body.rdt_cid = rdt_cid;
  if (eclid) body.eclid = eclid;
  if (isMarketingPath) body.landing_path = landingPath;
  if (isMarketingPath && referrer) body.referrer = referrer;

  fetch(`${API_BASE_URL}/v1/attribution/fingerprint`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  }).catch(() => {
    // Fire-and-forget — silently ignore errors
  });
}
